import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Governance",
  "description": "Turborepo by Vercel is the next-generation build system for the web."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo was created by the team at Vercel in 2020."
  }, {
    "heading": "",
    "content": "The research and development of Turborepo is led by the core team working full-time at Vercel. Turborepo is a collaborative open-source effort to build tools for web developers."
  }, {
    "heading": "teams",
    "content": "Core Team: The Turborepo team at Vercel manages the direction of Turborepo and leads the project."
  }, {
    "heading": "teams",
    "content": "Documentation: DevRel teams at Vercel manage documentation and learning platforms."
  }, {
    "heading": "roadmap-and-rfc-process",
    "content": "Large architecture decisions and features start as a Request for Comments (RFC) inside GitHub Discussions. The entire Turborepo community is invited to be involved in the process and discuss the tradeoffs of proposed work."
  }, {
    "heading": "roadmap-and-rfc-process",
    "content": "This process is essential to ensure features are built together with the community and our collaborators. More minor changes including bug fixes and documentation improvements are still implemented through GitHub pull requests. However, for larger initiatives, we believe it's essential to follow the RFC process."
  }, {
    "heading": "stability-and-release-phases",
    "content": "Experimental: Experimental features lack essential capabilities required to be ready for stability. The feature is considered to be under active development and is being built to transition into Beta."
  }, {
    "heading": "stability-and-release-phases",
    "content": "Beta: Beta means the feature does not yet meet our quality standards for a stable release. There is also usually a need for more information or feedback from Turborepo developers to validate this feature works as expected in a variety of environments."
  }, {
    "heading": "stability-and-release-phases",
    "content": "Stable: When the features reach stability, it is considered ready for use in production. APIs marked as stable will only change in a backward-compatible way unless there is a major release."
  }, {
    "heading": "stability-and-release-phases",
    "content": "Deprecated: A feature is in the process of being removed. Deprecated features include documentation for existing users with the next steps and information on when to expect the feature to be removed."
  }, {
    "heading": "turborepo-support",
    "content": "For individual developers looking for free support on their Turborepo repositories, they can ask questions in GitHub Discussions or in Vercel Community's #turborepo tag."
  }, {
    "heading": "turborepo-support",
    "content": "For companies looking for paid support on their Turborepo repositories, they can contact the Turborepo team at Vercel for more information."
  }, {
    "heading": "additional-resources",
    "content": "Logo Policy and Brand Guidelines"
  }, {
    "heading": "additional-resources",
    "content": "Reporting Security Issues"
  }, {
    "heading": "additional-resources",
    "content": "Code of Conduct"
  }, {
    "heading": "additional-resources",
    "content": "Contributing Guidelines"
  }],
  "headings": [{
    "id": "teams",
    "content": "Teams"
  }, {
    "id": "roadmap-and-rfc-process",
    "content": "Roadmap and RFC Process"
  }, {
    "id": "stability-and-release-phases",
    "content": "Stability and release phases"
  }, {
    "id": "turborepo-support",
    "content": "Turborepo Support"
  }, {
    "id": "additional-resources",
    "content": "Additional Resources"
  }]
};
export const toc = [{
  depth: 2,
  url: "#teams",
  title: _jsx(_Fragment, {
    children: "Teams"
  })
}, {
  depth: 2,
  url: "#roadmap-and-rfc-process",
  title: _jsx(_Fragment, {
    children: "Roadmap and RFC Process"
  })
}, {
  depth: 2,
  url: "#stability-and-release-phases",
  title: _jsx(_Fragment, {
    children: "Stability and release phases"
  })
}, {
  depth: 2,
  url: "#turborepo-support",
  title: _jsx(_Fragment, {
    children: "Turborepo Support"
  })
}, {
  depth: 2,
  url: "#additional-resources",
  title: _jsx(_Fragment, {
    children: "Additional Resources"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo was created by the team at ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), " in 2020."]
    }), "\n", _jsx(_components.p, {
      children: "The research and development of Turborepo is led by the core team working full-time at Vercel. Turborepo is a collaborative open-source effort to build tools for web developers."
    }), "\n", _jsx(_components.h2, {
      id: "teams",
      children: "Teams"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Core Team"
      }), ": The Turborepo team at ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), " manages the direction of Turborepo and leads the project."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Documentation"
      }), ": DevRel teams at ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), " manage documentation and learning platforms."]
    }), "\n", _jsx(_components.h2, {
      id: "roadmap-and-rfc-process",
      children: "Roadmap and RFC Process"
    }), "\n", _jsxs(_components.p, {
      children: ["Large architecture decisions and features start as a ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/categories/rfc",
        children: "Request for Comments (RFC)"
      }), " inside GitHub Discussions. The entire Turborepo community is invited to be involved in the process and discuss the tradeoffs of proposed work."]
    }), "\n", _jsx(_components.p, {
      children: "This process is essential to ensure features are built together with the community and our collaborators. More minor changes including bug fixes and documentation improvements are still implemented through GitHub pull requests. However, for larger initiatives, we believe it's essential to follow the RFC process."
    }), "\n", _jsx(_components.h2, {
      id: "stability-and-release-phases",
      children: "Stability and release phases"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Experimental"
        }), ": Experimental features lack essential capabilities required to be ready for stability. The feature is considered to be under active development and is being built to transition into Beta."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Beta"
        }), ": Beta means the feature does not yet meet our quality standards for a stable release. There is also usually a need for more information or feedback from Turborepo developers to validate this feature works as expected in a variety of environments."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Stable"
        }), ": When the features reach stability, it is considered ready for use in production. APIs marked as stable will only change in a backward-compatible way unless there is a major release."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Deprecated"
        }), ": A feature is in the process of being removed. Deprecated features include documentation for existing users with the next steps and information on when to expect the feature to be removed."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "turborepo-support",
      children: "Turborepo Support"
    }), "\n", _jsxs(_components.p, {
      children: ["For individual developers looking for free support on their Turborepo repositories, they can ask questions in ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions",
        children: "GitHub Discussions"
      }), " or in ", _jsxs(_components.a, {
        href: "https://community.vercel.com/tag/turborepo",
        children: ["Vercel Community's ", _jsx(_components.code, {
          children: "#turborepo"
        }), " tag"]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["For companies looking for paid support on their Turborepo repositories, they can ", _jsx(_components.a, {
        href: "https://vercel.com/contact",
        children: "contact the Turborepo team at Vercel"
      }), " for more information."]
    }), "\n", _jsx(_components.h2, {
      id: "additional-resources",
      children: "Additional Resources"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://vercel.com/design/brands#turbo",
          children: "Logo Policy and Brand Guidelines"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/SECURITY.md",
          children: "Reporting Security Issues"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/CODE_OF_CONDUCT.md",
          children: "Code of Conduct"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/CONTRIBUTING.md",
          children: "Contributing Guidelines"
        })
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
